import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { select, Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import { AppConfig } from 'src/app/helpers/app.config';
import { Consultant } from 'src/app/models/consultant.model';
import { Invitation, InvitationSearch } from 'src/app/models/invitation.model';
import { Pagination } from 'src/app/models/pagination.model';
import { fromConsultant } from 'src/app/reducers/consultant.reducer';
import { fromInvitationsSearch } from 'src/app/reducers/invitations-search.reducer';
import { ReportService } from 'src/app/services/report.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'ct-export-scores',
  templateUrl: './export-scores.component.html',
  styleUrls: ['./export-scores.component.scss']
})
export class ExportScoresComponent implements OnInit {

  modalRef: NgbModalRef;
  closeResult: string;

  HCC: number[] = [];
  officeId: number;
  currentInvitationSearch: InvitationSearch;
  showSpinner = false;

  consultant$: Observable<Consultant>;
  invitations$: Observable<Pagination<Invitation>>;
  invitationSearch$: Observable<InvitationSearch>;
  currentConsultant: Consultant;

  @ViewChild('exportScoresModal') exportScoresModal;

  constructor(
    private modal: NgbModal,
    private store: Store,
    public utilsService: UtilsService,
    private reportService: ReportService
  ) { }

  ngOnInit(): void {
    this.showSpinner = false;
    this.consultant$ = this.store.pipe(select(fromConsultant.selectConsultantState));
    this.invitationSearch$ = this.store.pipe(select(fromInvitationsSearch.selectInvitationsSearchState));

    this.HCC = AppConfig.settings.OFFICES_WITH_PROJECTS.split(',').map(officeId => Number(officeId));

    // Nos suscribimos al consultor y invitatonSearch
    combineLatest([
      this.invitationSearch$,
      this.consultant$,
    ]).subscribe(([invitationSearch, consultant]) => {
      this.officeId = consultant.office.randstadOffice;
      this.currentInvitationSearch = invitationSearch;
      this.currentConsultant = consultant;
    });
  }

  open() {
    this.showSpinner = false;
    if (!this.modal.hasOpenModals()) {
      this.modalRef = this.modal.open(this.exportScoresModal,
        { ariaLabelledBy: 'Ver-Competencias', centered: true, backdrop: 'static', keyboard: false, size: 'xl' }
      );
      this.modalRef.result.then((result) => {
        this.closeResult = 'Closed with: ' + result;
      }, (reason) => {
        // this.closeResult = 'Dismissed ' + this.getDismissReason(reason);
      });
    }
  }

  // Si tras leer las instrucciones acepta, se mostrará el spinner
  confirmShowSpinner() {
    this.showSpinner = true;
    this.getExportScores();
  }

  /**
   * Candidate ID ,Email, Documento, Nombre y Apellido, Periodo de búsqueda,Invitación ID
   *  Proceso, Jobtype, Tipo de Prueba (se checkea también en BACK), Enviados por mi oficina, mis tests, o todos.
   */
  getExportScores() {
    const reportParams = {
      randstadCandidate: this.currentInvitationSearch.randstadCandidate,
      email: this.currentInvitationSearch.email,
      idCard: this.currentInvitationSearch.idCard,
      name: this.currentInvitationSearch.name,
      surname: this.currentInvitationSearch.surname,
      invitationId: this.currentInvitationSearch.invitationId,
      testId: this.currentInvitationSearch.testId,
      process: this.currentInvitationSearch.process,
      status: this.currentInvitationSearch.status,
      jobtype: this.currentInvitationSearch.jobtype,
      testModel: this.currentInvitationSearch.testModel,
      createdBy: this.currentInvitationSearch.createdBy,
      officeId: this.currentConsultant.office.id,
      consultantOfficeId: this.currentConsultant.office.id,
      consultantUniqueName: this.currentInvitationSearch.consultantUniqueName,
      period: this.currentInvitationSearch.period,
      clientId: this.currentConsultant.client.id
    };

    // limpiamos parámetros
    const cleanReportParams = this.utilsService.cleanParams(reportParams);
    this.reportService.getExportScores(cleanReportParams).subscribe(excel => {
      const downloadLink = document.createElement('a');
      downloadLink.href = excel;
      downloadLink.download = '';
      downloadLink.click();
    }, error => {
      this.utilsService.toast('error', 'Unexpected', true, this.utilsService.getNacsData({endpoint: 'GET' + AppConfig.settings.API + ' /export/scores?origin=ct', body: cleanReportParams, error: {errorType: error.errorType, errorCode: error.errorCode, message: error.message}}));
      this.showSpinner = false;
      this.modal.dismissAll();
    },
    () => {
      // Cerramos modal y ponemos la valor del spinner a falso, para mostrar las instrucciones
      // cada vez que se abre la modal
      this.showSpinner = false;
      this.modal.dismissAll();
    });
  }

}
